import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import App from './App';
import reducer from './reducers';
import './index.css';

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('fcpay-admin-app');
  if (typeof element !== 'undefined' && element !== null) {
    const store = createStore(reducer);

    ReactDOM.render(
      <Provider store={store}>
        <App />
      </Provider>,
      document.getElementById('fcpay-admin-app')
    );
  }
});
